import type { To } from 'react-router';
import { useViewTransitionState as baseUseViewTransitionState } from 'react-router';

export const useViewTransitionState = (path: To) => {
  let isTransitioning = false;
  try {
    isTransitioning = baseUseViewTransitionState(path);
  } catch {
    // mostly for storybook where the story is not wrapped in StoryDecorator
  }
  return isTransitioning;
};
